import React from 'react';
import '../../css/SponsoredSection.css';

const SponsoredSection = () => {
    return (
        <div className="sponsored-section">
            <div className="container">
                <p className="attribution-text">
                    COLLABORATION WITH
                </p>
                <div className="sponsorship-banner">
                    <img src="/assets/images/digimar_eu.png" alt="Co-funded by the European Union and Digimar" className="sponsorship-image" />
                </div>
                <div className="sponsorship-banner">
                    <img src="/assets/images/chalmers-LOGO.png" alt="Made by Chalmers" className="sponsorship-image" />
                </div>
            </div>
        </div>
    );
};

export default SponsoredSection;